import { UserManager, WebStorageStateStore } from "oidc-client";

export default class AuthService {
  userManager;
  user;
 

  constructor() { 
    let that = this;
    let currentLocation = window.location.href.endsWith('/') ? window.location.href.slice(0, -1) :window.location.href;
    let accessTokenUrlIndex =currentLocation.indexOf('/#access_token=');

    if(accessTokenUrlIndex > 0){
      currentLocation =  currentLocation.slice(0,accessTokenUrlIndex);
    }

    let redirectUri = process.env.VUE_APP_AD_ALLOWED_REDIRECT_URIS.indexOf(currentLocation) >=0  ?currentLocation :process.env.VUE_APP_AD_REDIRECT_URI;     
    let redirectLogOutUri = process.env.VUE_APP_AD_ALLOWED_REDIRECT_URIS.indexOf(currentLocation) >=0  ?currentLocation :process.env.VUE_APP_AD_LOGOUT_REDIRECT_URI;
 
    const settings = {
      userStore: new WebStorageStateStore({ store: window.sessionStorage }),
      authority:`${process.env.VUE_APP_AD_AUTHORITY}`,
      client_id: this.getValidClientId(currentLocation),
      redirect_uri: `${redirectUri}`,
      response_type: "id_token token",
      scope: 'openid profile email',
      post_logout_redirect_uri: `${redirectLogOutUri}`,
      filterProtocolClaims: true,
      automaticSilentRenew:true,
      accessTokenExpiringNotificationTime:60,//default
      silentRequestTimeout:10000,
      silent_redirect_uri:`${redirectUri.endsWith('/')?redirectUri:redirectUri+'/'}${process.env.VUE_APP_AD_SILENT_REDIRECT_URI}`,
      metadata: {
        issuer: `${process.env.VUE_APP_AD_ISSUER}`,
        authorization_endpoint: `${process.env.VUE_APP_AD_AUTHORIZE_ENDPOINT}` ,
        userinfo_endpoint: `${process.env.VUE_APP_AD_USERINFO_ENDPOINT}`,
        end_session_endpoint: `${process.env.VUE_APP_AD_END_SESSION_ENDPOINT}`,
        jwks_uri:`${process.env.VUE_APP_AD_KWKS_URI}`

      }
    };


    that.userManager = new UserManager(settings);

    this.setUser();

  }

  async setUser(){
    let that=this;
    await that.userManager.getUser().then(user => {
      that.user = user;
    }); 
  }
  getUser() {
    return this.userManager.getUser();
  }

  login() {
    return this.userManager.signinRedirect();
  }

  completeAuthentication() {
    
    let that =this;
    var promise = new Promise(function(resolve,){
      that.getUser().then(u=>{
        if(u==null || u.expired){
            that.userManager
            .signinRedirectCallback()
            .then(c => {
                    that.user = c;
                    resolve(c);
            })
            .catch(function (err) {
              resolve(`error:${err}`);
            });
        }else{
          resolve(u);
        }
      });
    });
    return promise;  
  }

  logout() {
    return this.userManager.signoutRedirect();
  }
  getToken() {
    let that = this;
    return that.getUser().then(u=>{ 
              that.user = u;
              return u && u.access_token
            });        
  }

  silentRefresh(){
    
    let that = this;
  return that.userManager.signinSilent().then(u=>{
      console.info('token refershed');
      that.user = u;
      return u;
    }).catch(function (err) {
      console.error('error renew token');
      console.log(err);
      that.login();
  });
  }

  getValidClientId(currentLocation){
    let clientId =  process.env.VUE_APP_AD_CLIENT_ID;
    let clientIdList = JSON.parse(process.env.VUE_APP_AD_ALLOWED_CLIENT_ID);

    let clientIdIndex = clientIdList.findIndex(x=>x.includes(`${currentLocation};`));
    if(clientIdIndex >= 0 ){
      clientId =  clientIdList[clientIdIndex].split(';')[1]
    }

    return clientId;
  }
}